var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 7.5H5.83301",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3338 9.14164V10.8584C18.3338 11.3167 17.9672 11.6917 17.5005 11.7083H15.8672C14.9672 11.7083 14.1422 11.05 14.0672 10.15C14.0172 9.62499 14.2172 9.13332 14.5672 8.79165C14.8755 8.47498 15.3005 8.29167 15.7672 8.29167H17.5005C17.9672 8.30834 18.3338 8.6833 18.3338 9.14164Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.567 8.79166C14.217 9.13333 14.017 9.625 14.067 10.15C14.142 11.05 14.967 11.7083 15.867 11.7083H17.5003V12.9167C17.5003 15.4167 15.8337 17.0833 13.3337 17.0833H5.83366C3.33366 17.0833 1.66699 15.4167 1.66699 12.9167V7.08334C1.66699 4.81667 3.03366 3.23334 5.15866 2.96667C5.37533 2.93334 5.60033 2.91667 5.83366 2.91667H13.3337C13.5503 2.91667 13.7587 2.92499 13.9587 2.95833C16.1087 3.20833 17.5003 4.80001 17.5003 7.08334V8.29168H15.767C15.3003 8.29168 14.8753 8.475 14.567 8.79166Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7c7081dc131dcbdc3bf5db43e59752e3.svg";
export { ForwardRef as ReactComponent };